export const tableHead = [
    {
        title: "Group Name",
        width: "15%",
        sortKey: "name",
    },
    {
        title: "Creator",
        width: "9%",
        textAlign: "center",
    },
    {
        title: "Contact Number",
        width: "10%",
        textAlign: "center",
    },
    {
        title: "Based in",
        width: "8%",
        textAlign: "center",
    },
    {
        title: "Date Created",
        sortKey: "createdAt",
        width: "8%",
        textAlign: "center",
    },
    {
        title: "Members",
        sortKey: "members",
        width: "6%",
        textAlign: "center",
    },
    {
        title: "Distance",
        sortKey: "distance",
        width: "6%",
        textAlign: "center",
    },
    {
        title: "Completed Rides",
        sortKey: "rides",
        width: "6%",
        textAlign: "center",
    },
    {
        title: "Created Rides",
        sortKey: "createdRides",
        width: "8%",
        textAlign: "center",
    },
    {
        title: "Visibiity",
        width: "7%",
        textAlign: "center",
    },
    {
        title: "Verified",
        sortKey: "isVerified",
        width: "8%",
        textAlign: "center",
    },
    {
        title: "Payment",
        sortKey: "payment",
        width: "8%",
        textAlign: "center",
    },
    {
        title: "Action",
        sortKey: "",
        width: "3%",
        textAlign: "center",
    },
];
